import { render, staticRenderFns } from "./saveComment.vue?vue&type=template&id=08555b70&"
import script from "./saveComment.vue?vue&type=script&lang=js&"
export * from "./saveComment.vue?vue&type=script&lang=js&"
import style0 from "./saveComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports